import WasteFlowFormChevron from "./WasteFlowFormChevron";
import {
  WASTE_FORM_INPUT_CLASS,
  WASTE_FORM_LABEL_CLASS,
  WASTE_FORM_REQUIRED,
} from "./wasteFlowFormUi";

const WasteFlowNativeSelect = ({
  id,
  label,
  value,
  onChange,
  children,
  required = false,
}) => (
  <div className="waste-flow-form-field">
    <label className={WASTE_FORM_LABEL_CLASS} htmlFor={id}>
      {label} {required ? WASTE_FORM_REQUIRED : null}
    </label>
    <div className="relative">
      <select
        id={id}
        className={`${WASTE_FORM_INPUT_CLASS} appearance-none bg-white pr-10 cursor-pointer`}
        value={value}
        onChange={onChange}
        required={required}
      >
        {children}
      </select>
      <div
        className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
        aria-hidden
      >
        <WasteFlowFormChevron />
      </div>
    </div>
  </div>
);

export default WasteFlowNativeSelect;
